import { FileUploadType } from '@aslanpay/file-processing-service-client';

export const GALLERY_LIMIT = 10;
export const VIDEO_LIMIT = 5;
export const MAX_LOGO_SIZE_MB = 2;
export const MAX_IMAGE_SIZE_MB = 5;

export interface MediaFieldsProps {
  uploadFile: (file: File, uploadType: FileUploadType) => Promise<string>;
}
